import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { ReactSession } from 'react-client-session';
import ReactGA from 'react-ga';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import Homepage from "./Components/Homepage/Homepage";
import Login from "./Components/Login/Login";
import Register from './Components/Register/Register';
import VerifyEmail from './Components/VerifyEmail/VerifyEmail';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import ChangePassword from './Components/ChangePassword/ChangePassword';
import Premium from './Components/Premium/Premium';
import Videos from './Components/Videos/Videos';
import Images from './Components/Images/Images';
import Groups from './Components/Groups/Groups';
import Group from './Components/Group/Group';
import WebLinks from './Components/WebLinks/WebLinks'
import WebLink from './Components/WebLink/WebLink'
import Search from './Components/Search/Search';
import Music from './Components/Music/Music';
import Profile from './Components/Profile/Profile';
import Video from './Components/Video/Video';
import Play from './Components/Play/Play';
import Image from './Components/Image/Image';
import Category from './Components/Category/Category';
import Galleries from './Components/Galleries/Galleries';
import Album from './Components/Album/Album';
import Playlists from './Components/Playlists/Playlists';
import Playlist from './Components/Playlist/Playlist';
import AddVideo from './Components/Uploads/AddVideo/AddVideo';
import Logout from './Components/Logout/Logout';
// import Products from './Components/Products/Products';
// import ViewProduct from './Components/ViewProduct/ViewProduct';
import Cart from './Components/Cart/Cart';

import Dashboard from './Components/Dashboard/Home/Home';
import Referral from './Components/Dashboard/Referral/Referral';
// import Orders from './Components/Dashboard/Orders/Orders';
import Settings from './Components/Dashboard/Settings/Settings';
import Messages from './Components/Dashboard/Messages/Messages';
import Notifications from './Components/Dashboard/Notifications/Notifications';
import MyVideos from './Components/Dashboard/Videos/Videos';
import AddWebGroup from './Components/Uploads/AddWebGroup/AddWebGroup';
import AddWebLink from './Components/Uploads/AddWebLink/AddWebLink';
import AddImage from './Components/Uploads/AddImage/AddImage';
import Share from './Components/Uploads/Share/Share';
import SoundCloud from './Components/Uploads/Share/SoundCloud/SoundCloud';
import AddMusic from './Components/Uploads/AddMusic/AddMusic';
import Payments from './Components/Dashboard/Payments/Payments';
import Analytics from './Components/Dashboard/Analytics/Analytics';
import Activities from './Components/Dashboard/Activities/Activities';
import MyImages from './Components/Dashboard/Images/Images';
import MyMusics from './Components/Dashboard/Musics/Musics';
import EditVideo from './Components/Dashboard/EditVideo/EditVideo';
import EditImage from './Components/Dashboard/EditImage/EditImage';

import MyGroups from './Components/Dashboard/Groups/Groups';
import EditMyGroup from './Components/Dashboard/EditGroup/EditGroup';
import MyWebPages from './Components/Dashboard/Webpages/Webpages'
import EditMyWebPage from './Components/Dashboard/EditWebpage/EditWebpage'

import MyAlbums from './Components/Dashboard/Albums/Albums';
import ManageAlbum from './Components/Dashboard/ManageAlbum/ManageAlbum';
import AddAlbum from './Components/Dashboard/AddAlbum/AddAlbum';
import MyPlaylists from './Components/Dashboard/Playlists/Playlists';
import ManagePlaylist from './Components/Dashboard/ManagePlaylist/ManagePlaylist';
import AddPlaylist from './Components/Dashboard/AddPlaylist/AddPlaylist';
import Channels from './Components/Channels/Channels';
import Activity from './Components/Activity/Activity';
import Page from './Components/Page/Page';

import Subscriptions from './Components/Dashboard/Subscriptions/Subscriptions'
import Payment from './Components/Dashboard/Payment/Payment'

import Page404 from './Components/404/404';

function initizeAnaytics() {
  ReactGA.initialize('UA-152755113-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

function App() {
  initizeAnaytics();
  // ReactSession.setStoreType("localStorage");
  
  // const logged_user = ReactSession.get("logged_user");
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Homepage/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/register" element={<Register/>} />
          <Route path="/register" element={<Register/>} />
          <Route path="/verifyemail" element={<VerifyEmail/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/change-password" element={<ChangePassword/>} />
          <Route path="/premium" element={<Premium/>} />
          <Route path="/videos" element={<Videos/>} />
          <Route path="/images" element={<Images/>} />
          <Route path="/galleries" element={<Galleries/>} />
          <Route path="/album/:id/:name" element={<Album/>} />
          <Route path="/playlists" element={<Playlists/>} />
          <Route path="/playlist/:id/:name" element={<Playlist/>} />
          <Route path="/groups" element={<Groups/>} />
          <Route path="/group/:gid/:name" element={<Group/>} />
          <Route path="/weblinks" element={<WebLinks/>} />
          <Route path="/weblink/:wid/:name" element={<WebLink/>} />
          <Route path="/search/:key" element={<Search/>} />
          <Route path="/music" element={<Music/>} />
          <Route path="/channels" element={<Channels/>} />
          <Route path="/profile/:uid/:username" element={<Profile/>} />
          <Route path="/video/:id/:title" element={<Video/>} />
          <Route path="/play/:id/:title" element={<Play/>} />
          <Route path="/channel/:name/:id" element={<Category/>} />
          
          <Route path="/video/:id/list/:uid" element={<Video/>} />
          <Route path="/video/:id/:title/list/:uid" element={<Video/>} />
          <Route path="/video/:id/playlist/:play_id" element={<Video/>} />
          <Route path="/video/:id/:title/playlist/:play_id" element={<Video/>} />
          
          <Route path="/image/:id/:title" element={<Image/>} />
          <Route path="/page/:id/:name" element={<Page/>} />
          
          {/* <Route path="/products" element={<Products/>} />
          <Route path="/product/:id" element={<ViewProduct/>} /> */}
          <Route path="/cart" element={<Cart/>} />
          <Route path="/logout" element={<Logout/>} />
          <Route path="/dashboard" element={<Dashboard/>} />
          <Route path="/dashboard/referral" element={<Referral/>} />
          {/* <Route path="/dashboard/orders" element={<Orders/>} /> */}
          <Route path="/dashboard/settings" element={<Settings/>} />
          <Route path="/dashboard/settings/:name" element={<Settings/>} />
          <Route path="/dashboard/messages" element={<Messages/>} />
          <Route path="/dashboard/messages/:c_id" element={<Messages/>} />
          <Route path="/dashboard/conversion/:uid" element={<Messages/>} />
          <Route path="/dashboard/notifications" element={<Notifications/>} />
          <Route path="/dashboard/videos" element={<MyVideos/>} />
          <Route path="/dashboard/payments" element={<Payments/>} />
          <Route path="/dashboard/analytics" element={<Analytics/>} />
          <Route path="/dashboard/activities" element={<Activities/>} />
          <Route path="/dashboard/images" element={<MyImages/>} />
          <Route path="/dashboard/musics" element={<MyMusics/>} />
          <Route path="/dashboard/groups/" element={<MyGroups/>} />
          <Route path="/dashboard/editgroup/:id" element={<EditMyGroup/>} />
          <Route path="/dashboard/webpages" element={<MyWebPages/>} />
          <Route path="/dashboard/editwebpage/:id" element={<EditMyWebPage/>} />
          <Route path="/dashboard/albums" element={<MyAlbums/>} />
          <Route path="/dashboard/album/:id" element={<ManageAlbum/>} />
          <Route path="/dashboard/add-album" element={<AddAlbum/>} />
          <Route path="/dashboard/playlists" element={<MyPlaylists/>} />
          <Route path="/dashboard/playlist/:id" element={<ManagePlaylist/>} />
          <Route path="/dashboard/add-playlist" element={<AddPlaylist/>} />

          <Route path="/activity/:type" element={<Activity/>} />
          <Route path="/add-video" element={<AddVideo/>} />
          <Route path="/add-music" element={<AddMusic/>} />
          <Route path="/add-weblink" element={<AddWebLink/>} />
          <Route path="/add-web-group" element={<AddWebGroup/>} />
          <Route path="/share" element={<Share/>} />
          <Route path="/share/soundcloud" element={<SoundCloud/>} />
          <Route path="/add-image" element={<AddImage/>} />
          <Route path="/dashboard/edit-video/:vid" element={<EditVideo/>} />
          <Route path="/dashboard/edit-image/:vid" element={<EditImage/>} />

          <Route path="/dashboard/subscriptions" element={<Subscriptions/>} />
          <Route path="/dashboard/payment" element={<Payment/>} />

          <Route path="*" exact={true} element={<Page404/>} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
